import React from "react";
import { FaChartLine, FaWallet, FaUsers, FaArrowRight } from "react-icons/fa";
import Header from "../General/Header";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
    <Header/>
    <div style={{ background: "#0f172a", color: "#fff", minHeight: "100vh" }}>
      
   
      <section
        style={{
          padding: "80px 20px",
          textAlign: "center",
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)",
        }}
      >
        <h1
          style={{
            fontSize: "55px",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          Smart Trading Platform
        </h1>

        <p
          style={{
            fontSize: "20px",
            maxWidth: "750px",
            margin: "0 auto",
            color: "#cbd5e1",
            lineHeight: "32px",
          }}
        >
          Trade smarter with real-time market analysis, secure transactions,
          portfolio management, and advanced trading tools.
        </p>

        <div style={{ marginTop: "35px" }}>
          <button
            style={{
              padding: "14px 32px",
              background: "#22c55e",
              border: "none",
              borderRadius: "10px",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
              marginRight: "15px",
              fontWeight: "600",
            }}
          >
            Start Trading
          </button>

         <button
  onClick={() => navigate("/about")}
  style={{
    padding: "14px 32px",
    background: "transparent",
    border: "2px solid #22c55e",
    borderRadius: "10px",
    color: "#22c55e",
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "600",
  }}
>
  Learn More
</button>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: "70px 20px" }}>
        <h2
          style={{
            textAlign: "center",
            fontSize: "38px",
            marginBottom: "50px",
          }}
        >
          Why Choose Us
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "25px",
            maxWidth: "1200px",
            margin: "auto",
          }}
        >
          {/* Card 1 */}
          <div
            style={{
              background: "#1e293b",
              padding: "30px",
              borderRadius: "15px",
              textAlign: "center",
            }}
          >
            <FaChartLine size={45} color="#22c55e" />
            <h3 style={{ marginTop: "20px" }}>Live Market</h3>
            <p style={{ color: "#cbd5e1", marginTop: "10px" }}>
              Track real-time stock and crypto market updates instantly.
            </p>
          </div>

          {/* Card 2 */}
          <div
            style={{
              background: "#1e293b",
              padding: "30px",
              borderRadius: "15px",
              textAlign: "center",
            }}
          >
            <FaWallet size={45} color="#22c55e" />
            <h3 style={{ marginTop: "20px" }}>Secure Wallet</h3>
            <p style={{ color: "#cbd5e1", marginTop: "10px" }}>
              Manage deposits, withdrawals, and transactions securely.
            </p>
          </div>

          {/* Card 3 */}
          <div
            style={{
              background: "#1e293b",
              padding: "30px",
              borderRadius: "15px",
              textAlign: "center",
            }}
          >
            <FaUsers size={45} color="#22c55e" />
            <h3 style={{ marginTop: "20px" }}>Expert Support</h3>
            <p style={{ color: "#cbd5e1", marginTop: "10px" }}>
              Get 24/7 support and trading guidance from professionals.
            </p>
          </div>
        </div>
      </section>

      <section
        style={{
          background: "#111827",
          padding: "60px 20px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "25px",
            textAlign: "center",
            maxWidth: "1100px",
            margin: "auto",
          }}
        >
          <div>
            <h2 style={{ fontSize: "40px", color: "#22c55e" }}>50K+</h2>
            <p>Active Traders</p>
          </div>

          <div>
            <h2 style={{ fontSize: "40px", color: "#22c55e" }}>₹100Cr+</h2>
            <p>Trading Volume</p>
          </div>

          <div>
            <h2 style={{ fontSize: "40px", color: "#22c55e" }}>99.9%</h2>
            <p>Secure Transactions</p>
          </div>

          <div>
            <h2 style={{ fontSize: "40px", color: "#22c55e" }}>24/7</h2>
            <p>Customer Support</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        style={{
          padding: "80px 20px",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "42px", marginBottom: "20px" }}>
          Ready To Start Trading?
        </h2>

        <p
          style={{
            color: "#cbd5e1",
            fontSize: "18px",
            marginBottom: "35px",
          }}
        >
          Join thousands of traders using our platform daily.
        </p>

        <button
          style={{
            padding: "16px 35px",
            background: "#22c55e",
            border: "none",
            borderRadius: "10px",
            color: "#fff",
            fontSize: "18px",
            cursor: "pointer",
            fontWeight: "600",
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          Get Started <FaArrowRight />
        </button>
      </section>

      {/* How It Works Section */}
<section
  style={{
    padding: "80px 20px",
    background: "#1e293b",
  }}
>
  <h2
    style={{
      textAlign: "center",
      fontSize: "40px",
      marginBottom: "20px",
    }}
  >
    How It Works
  </h2>

  <p
    style={{
      textAlign: "center",
      color: "#cbd5e1",
      maxWidth: "700px",
      margin: "0 auto 50px",
      lineHeight: "30px",
      fontSize: "18px",
    }}
  >
    Start your trading journey in just a few easy steps and grow
    your portfolio with confidence.
  </p>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "25px",
      maxWidth: "1200px",
      margin: "auto",
    }}
  >
    {/* Step 1 */}
    <div
      style={{
        background: "#0f172a",
        padding: "35px",
        borderRadius: "15px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50%",
          background: "#22c55e",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        1
      </div>

      <h3 style={{ marginTop: "25px" }}>Create Account</h3>

      <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
        Register your account securely and complete quick verification.
      </p>
    </div>

    {/* Step 2 */}
    <div
      style={{
        background: "#0f172a",
        padding: "35px",
        borderRadius: "15px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50%",
          background: "#22c55e",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        2
      </div>

      <h3 style={{ marginTop: "25px" }}>Add Funds</h3>

      <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
        Deposit money safely into your wallet using secure payment methods.
      </p>
    </div>

    {/* Step 3 */}
    <div
      style={{
        background: "#0f172a",
        padding: "35px",
        borderRadius: "15px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50%",
          background: "#22c55e",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        3
      </div>

      <h3 style={{ marginTop: "25px" }}>Start Trading</h3>

      <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
        Buy and sell assets with live market tracking and analytics.
      </p>
    </div>
  </div>
</section>
<Footer/>

    </div>
    </>
  );
};

export default Home;